import { Component, inject, input, linkedSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { LanguageService } from '../../../services/language.service';
import { UmamiService } from '../../../services/umami.service';

@Component({
    selector: 'app-language-selection',
    imports: [FormsModule, NgClass],
    templateUrl: './language-selection.component.html',
    styleUrl: './language-selection.component.css',
})
export class LanguageSelectionComponent {
    languageService = inject(LanguageService);
    umami = inject(UmamiService);
    selectedLanguage = linkedSignal(() => this.languageService.getLanguageCode);
    isMinimal = input<boolean>(false);
    changeLanguage(languageCode: string) {
        this.languageService.changeLanguage(languageCode);
        this.selectedLanguage.set(languageCode);
        this.umami.track('change-language', { language: languageCode });
    }
}
